// extracted by mini-css-extract-plugin
export default {"main":"main--dQswQ","side":"side--RqnOE"};